import React from 'react';
import BikeLogo from "../assets/logo.jpeg";
import { Link } from 'react-router-dom';
import styled from 'styled-components';

const Footer = () => {
    const Center = styled.p`
        text-align: center;
    `

    return (
        <footer>
            <div className="container">
                <div className="row row__column">
                    <Link to="/">
                        <figure className='footer__logo'>
                            <img src={BikeLogo} alt="The Bike Shop" className="footer__logo--img" />
                        </figure>
                    </Link>
                    <div className="footer__list">
                        <Link to="/" className="footer__link">
                            Home
                        </Link>
                        {/* <Link to="/about" className="footer__link">
                            About
                        </Link> */}
                        <Link to="/bikes" className="footer__link">
                            Bikes
                        </Link>
                        <Link onClick={() => alert("Feature coming soon!")} to="/" className="footer__link">
                            Login
                        </Link>
                        <Link to="/cart" className="footer__link">
                            Cart
                        </Link>
                        {/* <Link to="/contact" className="footer__link">
                            Contact
                        </Link> */}
                    </div>
                    <div className="footer__copyright">
                        Copyright &copy; 2023 - {new Date().getFullYear()} Library 
                        Developed by 
                        <Link 
                            to="https://kylepportfolio.netlify.app" 
                            className='dev'> Kyle Parsotan 
                        </Link>
                        <br />
                        <Center>
                            Not selling any Bicycles.
                        </Center>
                    </div>
                </div>
            </div>
        </footer>
    )
}

export default Footer;
